import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import FAQSection from '../components/sections/FAQSection';
import SectionDivider from '../components/common/SectionDivider';

const FAQPage = () => {
  const theme = useTheme();

  return (
    <Box component="main" sx={{ pt: 10 }}>
      <Container maxWidth="lg" sx={{ py: 2 }}>
        <Typography variant="h2" sx={{ 
          mb: 2, 
          fontWeight: 800, 
          textAlign: 'center',
          color: 'text.primary'
        }}>
          Frequently Asked Questions
        </Typography>
        <Typography variant="h6" sx={{ 
          mb: 3, 
          textAlign: 'center',
          color: 'text.secondary',
          maxWidth: 800,
          mx: 'auto'
        }}>
          Find answers to common questions about our mechanical contracting services and processes.
        </Typography>
      </Container>
      
      <SectionDivider variant="wave" color="divider" mt={1} mb={2} />
      
      <Box sx={{ background: `linear-gradient(180deg, ${theme.palette.grey[50]}, rgba(0,0,0,0.04))` }}>
        <FAQSection />
      </Box>
      
      <SectionDivider variant="line" color="divider" mt={6} mb={6} />
      
      <Container maxWidth="lg" sx={{ py: 4, textAlign: 'center' }}>
        <Typography variant="h5" sx={{ mb: 3, fontWeight: 600 }}>
          Still have questions?
        </Typography>
        <Button 
          variant="contained" 
          size="large"
          href="tel:(516) 414-0165"
          sx={{ 
            px: 4, 
            py: 2,
            fontSize: '1.1rem',
            fontWeight: 600
          }}
        >
          Call Us for Answers
        </Button>
      </Container>
    </Box>
  );
};

export default FAQPage;
